<div class="row">
    <div class="form-group col-sm-12 mb-0">
        <span *ngIf="!listaAnexos.length" class="p-2">Para começar, escolha arquivos abaixo.</span>
        <app-dim-datatable *ngIf="listaAnexos.length > 0" [loading]="loading['searchDocumentoAnexo']"
            [columns]="colunasDocumentosAnexos" [data]="listaAnexos" [paramConsulta]="paramConsulta.value"
            [rowsOnPage]="searchData.pageSize" [totalItems]="listaAnexos.length" [currentPage]="searchData.pageIndex"
            (sorting)="setOrdenation($event)" (pageChanged)="setPagination($event)" [acoes]="true">
            <ng-template #buttonsMaxTmpl let-row="row">
                <button [disabled]="loading['buscarArquivosAnexos'] || !row.id || anexosLoading"
                    class="btn btn-info btn-mini waves-effect waves-light" style="border-radius: 10%" type="button"
                    placement="left" ngbTooltip="Baixar documento" (click)="downloadDocumentoAnexo(row)">
                    <i class="icofont icofont-download-alt"></i>
                </button>

                <button [disabled]="loading['buscarArquivosAnexos'] || !row.id || anexosLoading"
                    class="btn btn-danger btn-mini waves-effect waves-light" style="border-radius: 10%" type="button"
                    placement="left" ngbTooltip="Excluir" (click)="handleOnExcluirDocumentoAnexo(row)">
                    <i class="ti ti-trash"></i>
                </button>
            </ng-template>
        </app-dim-datatable>
    </div>
</div>
<div class="row" *ngIf="botaoEnviarArquivoVisivel">
    <div class="d-flex flex-column col-sm-12 mt-2">
        <input type="file" multiple id="uploadAnexosDocumento" #uploadDocumentosAnexos
            [accept]="extensoesInputAccept.join(',')" (change)="handleOnChangeUploadDocumentosAnexos($event)"
            class="input-enviar-arquivo">

        <span class="p-2">Os arquivos são enviados automaticamente ao salvar.</span>
    </div>
</div>